module.exports = __webpack_public_path__ + "img/ch16_17_博览会门票.a1eff519.jpg";